export default "__VITE_ASSET__83c8a03c__"